import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Table } from 'antd'
import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'

import { ModuloModel } from '../../models/ModuloModel'
import { modulosStore, useModulosDispatch, useModulosState } from '../../stores/modulosStore'

interface ModulosViewProps {
  cursoId: number
}

export const ModulosView: React.FC<ModulosViewProps> = ({ cursoId }) => {
  const history = useHistory()
  const dispatch = useModulosDispatch()
  const { modulos, request } = useModulosState()

  useEffect(() => {
    dispatch(modulosStore.actions.setQueryParams({ limit: 1000, offset: 0 }))
    dispatch(modulosStore.thunks.modulosFetch({ cursoId: +cursoId }))
    return () => {
      dispatch(modulosStore.actions.setQueryParams({ limit: 10, offset: 0 }))
    }
  }, [cursoId, dispatch])

  useEffect(() => {
    if (!request.message) return
    toast.warn(request.message)
    dispatch(modulosStore.actions.requestClean())
  }, [dispatch, request.message])

  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'Nome', dataIndex: 'nome', key: 'nome' },
    {
      title: 'Ações',
      key: 'action',
      width: 90,
      render: (_, modulo: ModuloModel) => (
        <Popconfirm
          title="Excluir módulo"
          description="Tem certeza que deseja excluir este módulo?"
          okText="Excluir"
          cancelText="Cancelar"
          okButtonProps={{ danger: true }}
          onConfirm={() => dispatch(modulosStore.thunks.deleteModulo(+modulo.id))}
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={(e) => e.stopPropagation()}
          />
        </Popconfirm>
      ),
    },
  ]

  return (
    <SectionCard>
      <CardHeader>
        <SectionTitle>Módulos do curso</SectionTitle>
        <Button
          type="primary"
          onClick={() => history.push(`/cursos/${cursoId}/modulos/novo`, { cursoId })}
        >
          Criar novo módulo
        </Button>
      </CardHeader>

      <TableWrapper>
        <Table
          columns={columns}
          dataSource={modulos}
          rowKey="id"
          loading={request.fetching}
          locale={{ emptyText: 'Não há nenhum módulo cadastrado ainda.' }}
          onRow={(modulo) => ({
            onClick: () => history.push(`/cursos/${cursoId}/modulos/${modulo.id}/editar`),
            style: { cursor: 'pointer' },
          })}
          pagination={false}
        />
      </TableWrapper>
    </SectionCard>
  )
}

const SectionCard = styled.section`
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  padding: 20px;
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #494d50;
`

const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 10px;
  overflow-x: auto;

  .ant-table-thead > tr > th {
    background: #ffffff;
    color: #585858;
    font-weight: normal;
    border-bottom: 1px solid #e7e3ec;
    padding: 12px 16px;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e7e3ec;
    padding: 8px 16px;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr.ant-table-row.ant-table-row-hover > td {
    background: #eeeeee;
  }
`
